import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import atact120 from '../assets/atact120.png';

export default function SEO({ description, name, title, type }) {
  return (
    <Helmet>
      {/* standard metadata tags */}
      <title>{`${title} | A TACT Connect Management`}</title>
      <meta content={description} name="description" />
      {/* facebook tags */}
      <meta content={description} property="og:description" />
      <meta content={atact120} property="og:image" />
      <meta
        content="A TACT Management & Services Pte Ltd"
        property="og:site_name"
      />
      <meta content={title} property="og:title" />
      <meta content={type} property="og:type" />
      {/* twitter tags */}
      <meta content={type} name="twitter:card" />
      <meta content={name} name="twitter:creator" />
      <meta content={description} name="twitter:description" />
      <meta content={atact120} name="twitter:image" />
      <meta content={title} name="twitter:title" />
    </Helmet>
  );
}

SEO.propTypes = {
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
